import axiosInstance from "../Api/Axios";

export const handleDownload = async (type, name, queryParams) => {

  let apiUrl = `${process.env.REACT_APP_API_URL}/download?request_type=${type}`;

  if (typeof queryParams !== 'undefined') {
    apiUrl += "&" + queryParams;
  }

  const apiEndpoint = apiUrl;

  try {
    const response = await axiosInstance.get(apiEndpoint, {
      responseType: "blob", // Specify that the response is a binary blob
    });

    // Create a download link and trigger the download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${name}.pdf`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
    // Handle errors as needed
  }
};
